import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72034c2-4f95-4f18-be74-1d29b1871fdc/artifacts/djdyqu9t_IMG_1381.png";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [resetLink, setResetLink] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      if (data.reset_link) setResetLink(data.reset_link);
    } catch (err) {
      setError(err.response?.data?.detail || "Error al enviar");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5EEDB] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md animate-fade-in">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Refugium" className="w-16 h-16 rounded-full mx-auto mb-4" />
          <h1 className="font-heading text-3xl text-[#5B3E2E]">Recuperar contraseña</h1>
          <p className="text-sm text-[#5B3E2E]/60 mt-2">Te enviaremos un enlace para restablecerla</p>
        </div>

        {sent ? (
          <div className="bg-[#FDFAF4] rounded-3xl p-8 border border-[#5B3E2E]/10 text-center">
            <div className="w-16 h-16 rounded-full bg-[#6B9070]/10 flex items-center justify-center mx-auto mb-4">
              <Mail size={28} className="text-[#6B9070]" />
            </div>
            <h2 className="font-heading text-xl text-[#5B3E2E] mb-2">Revisa tu email</h2>
            <p className="text-sm text-[#5B3E2E]/60 mb-4">
              Si el email existe en nuestra plataforma, recibirás un enlace para restablecer tu contraseña.
            </p>
            {resetLink && (
              <div className="mt-4 p-3 bg-[#F0A82C]/10 rounded-xl">
                <p className="text-xs text-[#5B3E2E]/50 mb-1">Enlace de restablecimiento (modo desarrollo):</p>
                <a href={resetLink} data-testid="reset-link" className="text-xs text-[#E48D57] break-all hover:underline">{resetLink}</a>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="bg-[#FDFAF4] rounded-3xl p-8 border border-[#5B3E2E]/10">
            {error && (
              <div className="bg-[#D9534F]/10 text-[#D9534F] text-sm rounded-xl p-3 mb-4">{error}</div>
            )}
            <div className="mb-4">
              <Label htmlFor="email" className="text-[#5B3E2E] text-sm">Email</Label>
              <Input
                data-testid="forgot-email"
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 bg-transparent border-[#5B3E2E]/20 rounded-xl text-[#5B3E2E]"
                placeholder="tu@email.com"
              />
            </div>
            <Button
              data-testid="forgot-submit"
              type="submit"
              disabled={submitting}
              className="w-full bg-[#E48D57] hover:bg-[#D07C46] text-white rounded-full py-3 font-medium"
            >
              {submitting ? "Enviando..." : "Enviar enlace"}
            </Button>
          </form>
        )}

        <p className="text-center mt-6">
          <Link to="/login" className="text-sm text-[#5B3E2E]/40 hover:text-[#5B3E2E]/60 flex items-center justify-center gap-1">
            <ArrowLeft size={14} /> Volver al login
          </Link>
        </p>
      </div>
    </div>
  );
}
